import React, { useContext } from "react"
import { Link } from "react-router-dom"
import { SmartDateFormat } from "../../util/dates"
import CommentScreen from "../comments/CommentScreen"
import { TextAsImage } from "./TextAsImage"
import { PostListItemStyles } from "./constants"
import { CopyPostUrlLink } from "./CopyPostUrlLink"
import { ReactionBlock } from "./ReactionBlock"
import RelatedPosts from "./RelatedPosts"
import { UserContext } from "../HomeApp"
import clsx from "clsx"
import styles from "./styles.module.css"
import PremiereHeader from "./PremiereHeader"
import { PostListItemParams } from "../../types/posts"

export const EditorialListItem: React.FC<PostListItemParams> = ({
  post,
  setIsExpanded,
}) => {
  const { user } = useContext(UserContext)

  return (
    <div className="grid grid-cols-12">
      <div className={PostListItemStyles.contentDiv}>
        {post.cover_image_url_large ? (
          <img
            src={post.cover_image_url_large}
            alt={post.title}
            onClick={(e) => setIsExpanded(true)}
            className={clsx(
              styles.editorialHeaderImage,
              "cursor-pointer",
              "w-full",
            )}
          />
        ) : (
          <TextAsImage text={post.title} />
        )}
      </div>

      <div className={PostListItemStyles.metaDiv}>
        <PremiereHeader post={post} size="small" />
        <div className="flex items-start">
          <h2
            className={clsx(
              PostListItemStyles.header,
              post.title.length > 100
                ? PostListItemStyles.headerLong
                : PostListItemStyles.headerShort,
              "cursor-pointer",
              post.is_bn_premiere && styles.premiereTitle,
            )}
            onClick={(e) => setIsExpanded(true)}
          >
            {post.title}
          </h2>
          <CopyPostUrlLink nadaUrl={post.nada_url} renderMode="icon" />
        </div>
        <div className={styles.subtitle}>{post.subtitle}</div>

        <Link className={PostListItemStyles.bandName} to={post.local_path}>
          {post.band_name}
        </Link>
        <h3 className={PostListItemStyles.postDate}>
          {SmartDateFormat({
            dateStr: post.published_at,
            includeTime: false,
          })}
        </h3>
        <div className={styles.editorialBlurb}>
          {post.editorial_blurb}...
          <div className="mt-2">
            <button
              className="text-blue-500 text-sm focus:outline-none"
              onClick={(e) => setIsExpanded(true)}
            >
              Read Full Post
            </button>
          </div>
        </div>
        <div className="mt-4">
          <RelatedPosts postId={post.id} />
        </div>
        <div className="mt-6">
          <ReactionBlock
            contentType="Post"
            contentId={post.id}
            postId={post.id}
          />
        </div>
        <CommentScreen postId={post.id} />
      </div>
    </div>
  )
}
